import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { useTenant } from '../../contexts/TenantContext';

interface TenantFooterProps {
  isDarkMode?: boolean;
  className?: string;
}

/**
 * Always-on footer attribution. On a tenant subdomain renders:
 *   © IITM 2026 · powered by Vidya.ai
 * On platform renders:
 *   © Vidya.ai 2026
 */
export const TenantFooter: React.FC<TenantFooterProps> = ({
  isDarkMode: isDarkModeProp,
  className = '',
}) => {
  const theme = useTheme();
  const { tenant } = useTenant();
  const isDarkMode = isDarkModeProp ?? theme.isDarkMode;

  const year = new Date().getFullYear();
  const owner = tenant?.name ?? 'Vidya.ai';

  return (
    <footer
      className={`py-3 px-6 text-center text-xs tracking-wide border-t ${
        isDarkMode
          ? 'text-slate-400 border-slate-800'
          : 'text-gray-500 border-gray-200'
      } ${className}`}
    >
      © {owner} {year}
      {tenant && (
        <>
          {' '}· powered by <span className="font-medium">Vidya.ai</span>
        </>
      )}
    </footer>
  );
};

export default TenantFooter;
